import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import CarlineSelection from '../carline-selection'
import { loadConfigurationByVehicleCode } from '../../redux/actions/app/vehicleCode.actions'
import { useDispatch, useSelector } from 'react-redux'
import { loadConfigurationByPrString } from '../../redux/actions/app/prString.actions'
import configurationResetIsPendingSelector from '../../redux/selectors/pending-request/configurationResetIsPendingSelector'

const BasePathHandler: React.FC = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const configurationResetIsPending = useSelector(configurationResetIsPendingSelector)

    useEffect(() => {
        if (configurationResetIsPending) {
            return
        }

        const queryParams = new URLSearchParams(location.search)
        const vehicleCode = queryParams.get('audiCode') || queryParams.get('vehicleCode') ||
            queryParams.get('audicode') || queryParams.get('vehiclecode')
        const prString = queryParams.get('prString') || queryParams.get('prstring')

        if (vehicleCode) {
            dispatch(loadConfigurationByVehicleCode(vehicleCode))
        } else if (prString) {
            dispatch(loadConfigurationByPrString(prString))
        }
    }, [location, dispatch, configurationResetIsPending])

    return <CarlineSelection/>
}

export default BasePathHandler
